import yn from 'yn'

export default function getSteps(hotelLabels) {
	const componentSteps = []

	if (
		yn(process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS) &&
		yn(process.env.REACT_APP_COMPONENT_POST_ENHANCEMENTS)
	) {
		componentSteps.push(
			hotelLabels.rooms,
			hotelLabels.enhancements,
			hotelLabels.payment,
			hotelLabels.confirmation
		)
	} else if (yn(process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS)) {
		componentSteps.push(
			hotelLabels.rooms,
			hotelLabels.enhancements,
			hotelLabels.payment,
			hotelLabels.confirmation
		)
	} else if (yn(process.env.REACT_APP_COMPONENT_POST_ENHANCEMENTS)) {
		componentSteps.push(
			hotelLabels.rooms,
			hotelLabels.payment,
			hotelLabels.enhancements,hotelLabels.confirmation
		)
	} else {
		componentSteps.push(
			hotelLabels.rooms,
			hotelLabels.payment,
			hotelLabels.confirmation
		)
	}

	return componentSteps
}


// WEBPACK FOOTER //
// ./src/utilities/content/getSteps.js